import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import clone from "clone"
import times from "helpers/times"
import numeral from 'numeral'
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import moment from "moment"

class SalespersonPerformance extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			columns: [
				{
					Header: "Salesperson",
					accessor: "Salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "Salesperson"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Net Sales",
					accessor: "Net Sales",
					filterMethod: (f, r) => helpers.tableText(f, r, "Net Sales"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Net Sales"]
						})
						return total
					},
				},
				{
					Header: "Total Price",
					accessor: "Total Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return null
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "Total Price"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Total Price"]
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0")
						}
						return total
					},
				},
				{
					Header: "Avg Days Sale vs Input",
					accessor: "Average Days",
					filterMethod: (f, r) => helpers.tableText(f, r, "Average Days"),
					Footer: (props) => helpers.tableAverages(props, "Average Days", "0"),
				},
			],
			withoutRealtor: [
				{
					Header: "Salesperson",
					accessor: "Salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "Salesperson"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Net Sales",
					accessor: "Net Sales",
					filterMethod: (f, r) => helpers.tableText(f, r, "Net Sales"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Net Sales"]
						})
						return total
					},
				},
				{
					Header: "Total Price",
					accessor: "Total Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return null
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "Total Price"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Total Price"]
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0")
						}
						return total
					},
				},
			],
			withRealtor: [
				{
					Header: "Salesperson",
					accessor: "Salesperson",
					filterMethod: (f, r) => helpers.tableText(f, r, "Salesperson"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Net Sales",
					accessor: "Net Sales",
					filterMethod: (f, r) => helpers.tableText(f, r, "Net Sales"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Net Sales"]
						})
						return total
					},
				},
				{
					Header: "Total Price",
					accessor: "Total Price",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("$0,0")
						}
						return null
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "Total Price"),
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["Total Price"]
						})
						if (typeof total == "number") {
							return numeral(total).format("$0,0")
						}
						return total
					},
				},
			],
			sorted: [],
		}
	}

	filterChange = (e) => {
		let state = clone(this.state)
		state.filters[e.target.value] = !state.filters[e.target.value]
		this.setState(state)
	}

	toggleAll = (checked) => {
		let filters = clone(this.state.filters)
		_.forEach(filters, (v, k) => {
			filters[k] = checked
		})
		this.setState({ filters: filters })
	}

	buildTable = () => {
		let ret = []
		let store = {}
		let model = {
			totalSales: 0,
			totalPrice: 0,
			builder: 0,
			gross: 0, // total number of sales, for net number
			cancels: 0,
			avg_days: []
		}
		// First do actuals
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.cloneDeep(model), Object)
			}
			store[v.salesperson][v.lot_type].totalSales++
			store[v.salesperson][v.lot_type].totalPrice += v.price
			store[v.salesperson][v.lot_type].builder = v.builder
			store[v.salesperson][v.lot_type].avg_days.push(
				moment.unix(v.addedDate).diff(moment.unix(v.sale_date), "days")
			)
		})
		// Now work on net
		_.forEach(this.props.payload.sales.current, (v) => {
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].gross++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].cancels++
		})
		_.forEach(store, (v, k) => {
			_.forEach(v, (row, lot_type) => {
				lot_type = parseInt(lot_type)
				k = parseInt(k)
				let find = _.find(this.props.payload.public.salespeople, { id: k })
				let builder = _.find(this.props.payload.public.builders, { id: row.builder })
				let type = _.find(this.props.payload.public.lot_types, { id: lot_type })
				if (!find || !type) {
					return
				}
				ret.push({
					Salesperson: `${find.first} ${find.last}`,
					Builder: !builder || builder.name,
					"Lot Type": type.name,
					"Actual Sales": row.totalSales,
					"Total Price": row.totalPrice,
					"Net Sales": row.gross - row.cancels,
					"Average Days": Math.round(_.sum(row.avg_days) / row.avg_days.length) || null
				})
			})
		})
		console.log(ret)
		return ret
	}

	buildWithRealtor = () => {
		let ret = []
		let store = {}
		let model = {
			totalSales: 0,
			totalPrice: 0,
			builder: 0,
			gross: 0, // total number of sales, for net number
			cancels: 0,
		}
		// First do actuals
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.realtor_involved) {
				return
			}
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].totalSales++
			store[v.salesperson][v.lot_type].totalPrice += v.price
			store[v.salesperson][v.lot_type].builder = v.builder
		})
		// Now work on net
		_.forEach(this.props.payload.sales.current, (v) => {
			if (!v.realtor_involved) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].gross++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (!v.realtor_involved) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].cancels++
		})
		//console.log(store)
		_.forEach(store, (v, k) => {
			_.forEach(v, (row, lot_type) => {
				lot_type = parseInt(lot_type)
				k = parseInt(k)
				let find = _.find(this.props.payload.public.salespeople, { id: k })
				let builder = _.find(this.props.payload.public.builders, { id: row.builder })
				let type = _.find(this.props.payload.public.lot_types, { id: lot_type })
				if (!find || !type) {
					return
				}
				ret.push({
					Salesperson: `${find.first} ${find.last}`,
					Builder: !builder || builder.name,
					"Lot Type": type.name,
					"Actual Sales": row.totalSales,
					"Total Price": row.totalPrice,
					"Net Sales": row.gross - row.cancels,
				})
			})
		})
		//console.log(ret)
		return ret
	}

	buildWithoutRealtor = () => {
		let ret = []
		let store = {}
		let model = {
			totalSales: 0,
			totalPrice: 0,
			builder: 0,
			gross: 0, // total number of sales, for net number
			cancels: 0,
		}
		// First do actuals
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.realtor_involved) {
				return
			}
			if (v.bustout_date || v.transfer_date || v.cancel_date) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].totalSales++
			store[v.salesperson][v.lot_type].totalPrice += v.price
			store[v.salesperson][v.lot_type].builder = v.builder
		})
		// Now work on net
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.realtor_involved) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].gross++
		})
		_.forEach(this.props.payload.bustouts.current, (v) => {
			if (v.realtor_involved) {
				return
			}
			let path = `${v.salesperson}.${v.lot_type}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}
			store[v.salesperson][v.lot_type].cancels++
		})
		//console.log(store)
		_.forEach(store, (v, k) => {
			_.forEach(v, (row, lot_type) => {
				lot_type = parseInt(lot_type)
				k = parseInt(k)
				let find = _.find(this.props.payload.public.salespeople, { id: k })
				let builder = _.find(this.props.payload.public.builders, { id: row.builder })
				let type = _.find(this.props.payload.public.lot_types, { id: lot_type })
				if (!find || !type) {
					return
				}
				ret.push({
					Salesperson: `${find.first} ${find.last}`,
					Builder: !builder || builder.name,
					"Lot Type": type.name,
					"Actual Sales": row.totalSales,
					"Total Price": row.totalPrice,
					"Net Sales": row.gross - row.cancels,
				})
			})
		})
		//console.log(ret)
		return ret
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Salesperson Performance" />
						<div className="content">
							<h2>Overview</h2>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="spPerformance"
								title="SalespersonPerformance"
							/>
							<h2>Without Realtor</h2>
							<FullTable
								data={this.buildWithoutRealtor()}
								columns={this.state.withoutRealtor}
								name="spPerformance__withoutRealtor"
								title="SalespersonPerformanceWithoutRealtor"
							/>
							<h2>With Realtor</h2>
							<FullTable
								data={this.buildWithRealtor()}
								columns={this.state.withRealtor}
								name="spPerformance__withRealtor"
								title="SalespersonPerformanceWithRealtor"
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SalespersonPerformance)
